<footer class="footer">
    <div class="container-fluid">
        <div class="row align-items-center">
            <div class="col-sm-4">
                {{year}} &copy; {{appName}}.
            </div>
            <div class="col-sm-4">
                <div class="footer-version text-center">
                    UI v{{uiVersion}} | API v{{apiVersion}}
                </div>
            </div>
            <div class="col-sm-4">
                <div class="text-sm-end d-none d-sm-block">
                    Design & Develop by Nirvy Technologies
                </div>
            </div>
        </div>
    </div>
</footer>
